import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";






















import TimberTypeFormSelect from "../../../../timber/components/timberType/TimberTypeForm/TimberTypeFormSelect";



import TimberClassFormSelect from "../../../../timber/components/timberClass/TimberClassForm/TimberClassFormSelect";
















import { PrimaryTimberStorage } from "../../../../timber/types/models/TimberStorage";

import TimberStorageFormSelect from "../../../../timber/components/timberStorage/TimberStorageForm/TimberStorageFormSelect";

import { useGetTimberStorageQuery } from "../../../../timber/apis/TimberStorage.api";

import { useGetCuttingQuery } from "../../../../timber/apis/Cutting.api";
import { PrimaryCutting } from "../../../../timber/types/models/Cutting";







import ShipmentFormSelect from "../../../../timber/components/shipment/ShipmentForm/ShipmentFormSelect";





















import { t, msg } from "@lingui/core/macro";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import {useLocation} from "react-router";



























const ShipmentFormSelect_shipmentId = ({watch, prefix = ''})  => {

    const [storageId,] = watch([
        'storageId',
    ])


    const { data: storage } = useGetTimberStorageQuery(
        PrimaryTimberStorage.fromId(storageId),
        { skip: !storageId }
    )

    const { data: cutting } = useGetCuttingQuery(
        storage?.cuttingId ? PrimaryCutting.fromId(storage.cuttingId) : PrimaryCutting.fromId(undefined),
        { skip: !storage?.cuttingId }
    )

    const allowsMultiStorage = cutting?.allowsMultiStorageShipments === true

    const filter = allowsMultiStorage
        ? { cuttingIdRefs: storage?.cuttingId ? [storage.cuttingId] : [] }
        : { storageIdRefs: storageId ? [storageId] : [] }

    return (
    <ShipmentFormSelect
        type="dynamicSelect"
        name="shipmentId"
        label={t`Shipment`}
        prefix={prefix}
        required={ false }

        filter={ filter }

    />
    )
}








export const initialFormStateFn = () => { return {
    
        
        timberKey: "",
        
    
        
        length: "",
        
    
        
        diameter: "",
        
    
        
        timberTypeId: null,
        
    
        
        classId: null,
        
    
        
        linked: false,
        
    
        
        barkThickness: null,
        
    
        
        externalKey: "",
        
    
        
        commited: false,
        
    
        
        storageId: null,
        
    
        
        shipmentId: null,
        
    
        
        localCreatedAt: formatDateTimeParam(new Date()),
        
    
        
        localUpdatedAt: formatDateTimeParam(new Date()),
        
    
        
        localDeletedAt: formatDateTimeParam(new Date()),
        
    
        
        description: "",
        
    
    }
}

export const useLocationFormState = () => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    initialFormState.storageId = PrimaryTimberStorage.fromQuery(location.state?.timberStorageId) || null;
    

    const { data: storageIdData } = useGetTimberStorageQuery(PrimaryTimberStorage.fromId(initialFormState.storageId), { skip: !initialFormState.storageId })
    

    return React.useMemo(() => initialFormState, [
        location.state,
        storageIdData,
        
        
    ])
}

export const formObject = {
    
    
        timberKey:
        string()
        .trim()
        .min(1, msg`Timber Key is required`),
    
    
        length:
        number()
                 .gte(100).lte(1000).transform((value) => (!value ? null : value))
                .and(coerce.number(msg`must be a number.`)),
    
    
        diameter:
        number()
                 .gte(20).lte(200).transform((value) => (!value ? null : value))
                .and(coerce.number(msg`must be a number.`)),
    
    
        timberTypeId:
        string()
                .nanoid(msg`Timber Type is required`)
                .min(1, msg`Timber Type is required`),
    
    
        classId:
        string()
                .nanoid(msg`Timber Class is required`)
                .min(1, msg`Timber Class is required`),
    
    
        linked:
        boolean()
        ,
    
    
        barkThickness:
        coerce.number()
                 .gte(0).nullish(),
    
    
        externalKey:
        string()
        .trim()
        .nullish(),
    
    
        commited:
        boolean()
        ,
    
    
        storageId:
        string()
                .nanoid(msg`Storage is required`)
                .min(1, msg`Storage is required`),
    
    
        shipmentId:
        string()
                .nanoid(msg`Shipment is required`)
                .nullish(),
    
    
        localCreatedAt:
        string()
        .trim()
        .nullish(),
    
    
        localUpdatedAt:
        string()
        .trim()
        .nullish(),
    
    
        localDeletedAt:
        string()
        .trim()
        .nullish(),
    
    
        description:
        string()
        .trim()
        .nullish(),
    
};

export const formSchema = object(formObject);

const LogAddForm = ({watch, prefix = ''})  => {
    return (
        <Container>
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'timberKey' }
       aria-label="timberKey"
       data-testid="timberKey"
       label={t`Timber Key`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'length' }
       aria-label="length"
       data-testid="length"
       label={t`Length (cm)`}
       
       type='number'
       checkNumber={true}
       forceNumber={true}
       
   />
   
   
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'diameter' }
       aria-label="diameter"
       data-testid="diameter"
       label={t`Diameter (cm)`}
       
       type='number'
       checkNumber={true}
       forceNumber={true}
       
   />
   
   
           
           
   
    
    <TimberTypeFormSelect
        type="select"
        name="timberTypeId"
        label={t`Timber Type`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
    
    <TimberClassFormSelect
        type="select"
        name="classId"
        label={t`Timber Class`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
   <crudgen.FormCheckbox
       required
       name={ prefix + 'linked' }
       aria-label="linked"
       data-testid="linked"

       label={t`Linked`}
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'barkThickness' }
       aria-label="barkThickness"
       data-testid="barkThickness"
       label={t`Bark Thickness`}
       
       type='number'
       checkNumber={true}
       forceNumber={true}
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'externalKey' }
       aria-label="externalKey"
       data-testid="externalKey"
       label={t`External Key`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormCheckbox
       required
       name={ prefix + 'commited' }
       aria-label="commited"
       data-testid="commited"

       label={t`Commited`}
   />
   
   
           
           
   
    
    <TimberStorageFormSelect
        type="dynamicSelect"
        name="storageId"
        label={t`Storage`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
    
    <ShipmentFormSelect_shipmentId
        watch={watch}
        prefix={prefix}
    />
   
   
   
           
           
   
        
           <crudgen.FormDateTime
                
                name={ prefix + 'localCreatedAt' }
                aria-label="localCreatedAt"
                label={t`Local Created At`}
           />
       
   
   
           
           
   
        
           <crudgen.FormDateTime
                
                name={ prefix + 'localUpdatedAt' }
                aria-label="localUpdatedAt"
                label={t`Local Updated At`}
           />
       
   
   
           
           
   
        
           <crudgen.FormDateTime
                
                name={ prefix + 'localDeletedAt' }
                aria-label="localDeletedAt"
                label={t`Local Deleted At`}
           />
       
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'description' }
       aria-label="description"
       data-testid="description"
       label={t`Description`}
       
       type='text'
       
   />
   
   
           
        </Container>
    )
}

export default LogAddForm;
